var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
// Ids assigned to job types via TE API docs
export var jobType;
(function (jobType) {
    jobType["SUMMER_JOB"] = "0005";
    jobType["APPRENTICESHIP"] = "0008";
    jobType["RENTAL_JOB"] = "0016";
    jobType["RECRUITMENT_ASSIGNMENT"] = "0017";
})(jobType || (jobType = {}));
var TEPreset = /** @class */ (function (_super) {
    __extends(TEPreset, _super);
    function TEPreset() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.title = null;
        return _this;
    }
    return TEPreset;
}(Entity));
export { TEPreset };
var Preset = /** @class */ (function (_super) {
    __extends(Preset, _super);
    function Preset() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.title = null;
        return _this;
    }
    return Preset;
}(Entity));
export { Preset };
